var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPrerender() || !_vm.loaded)?_c('div',[_vm._t("default",function(){return [_c('p',[_vm._v("Bezig met laden..")])]})],2):_c('div',{domProps:{"innerHTML":_vm._s(_vm.parsedAPITemplate)}})
}
var staticRenderFns = []

export { render, staticRenderFns }